// extracted by mini-css-extract-plugin
export var navbarSubLink = "x_gb d_gb d_f4 d_0 d_cc d_dm d_bs d_bT";
export var menuLink = "x_ty d_f0 d_dB";
export var subPageLink = "x_gf d_gf";
export var burger = "x_tY";
export var sublinkSize = "x_tZ";
export var linkSize = "x_t0";
export var Link = "x_rL q_rL q_qY q_rh";